import PortletConstants from './PortletConstants';

export default [
  PortletConstants.ANALYSIS,
  PortletConstants.CHART_STATIC,
  PortletConstants.PARK_CHARTS,
];
